import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import { tokens } from '@hotjar/hotsauce';
import { ThumbsUpIcon } from '@hotjar/webapp/components/ThumbsUpDownTooltip/ThumbsUpIcon';
import { ThumbsDownIcon } from '@hotjar/webapp/components/ThumbsUpDownTooltip/ThumbsDownIcon';

const Container = styled.div`
  padding: 0 ${tokens.spacer.x4} ${tokens.spacer.x3};
  font-size: 12px;
  color: ${tokens.color.neutral_300};
  display: flex;
  align-items: center;
`;

const LabelDiv = styled.div`
  margin-right: ${tokens.spacer.x1};
`;

const StyledButton = styled.button`
  cursor: pointer;
  border: 0;
  outline: none;
  display: flex;
  align-items: center;
  color: ${tokens.color.white};
  margin-right: ${tokens.spacer.x0};
  padding: 4px 9px;
  border-radius: 3px;

  ${(props) =>
    props.isToggled
      ? 'background: rgba(255, 255, 255, 0.5);'
      : `
  background: rgba(255, 255, 255, 0.08);
  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }`}
`;

export const ThumbsUpDownSection = ({ answer = null, onAnswerChange, isLoading }) => {
  const { t } = useTranslation();

  const handleYesClick = () => {
    if (answer === true) {
      onAnswerChange(null);
    } else {
      onAnswerChange(true);
    }
  };

  const handleNoClick = () => {
    if (answer === false) {
      onAnswerChange(null);
    } else {
      onAnswerChange(false);
    }
  };

  return (
    <Container>
      <LabelDiv> {t('common:player.thumbs-up-down-ending-question')}</LabelDiv>{' '}
      <StyledButton
        isToggled={answer === true}
        onClick={handleYesClick}
        disabled={isLoading}
        data-testid="thumbs-up"
      >
        <ThumbsUpIcon size={12} />
      </StyledButton>
      <StyledButton
        isToggled={answer === false}
        onClick={handleNoClick}
        disabled={isLoading}
        data-testid="thumbs-down"
      >
        <ThumbsDownIcon size={12} />
      </StyledButton>
    </Container>
  );
};

ThumbsUpDownSection.defaultProps = {
  answer: null,
  isLoading: false,
};

ThumbsUpDownSection.propTypes = {
  answer: PropTypes.bool, // null is a valid value for not answered
  onAnswerChange: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};
